export default __webpack_public_path__ + "static/media/thumbnail.9561a0f4.png";